module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "cup",
    style: (_vm.cupBackground)
  }, [_c('img', {
    staticClass: "catalyst",
    class: _vm.showDrop == true ? 'show' : '',
    attrs: {
      "src": "static/eye-dropper.png",
      "alt": "",
      "width": "400",
      "height": "400"
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "dots",
    attrs: {
      "width": "400",
      "height": "400",
      "viewBox": "0 0 400 400"
    }
  }, [_c('g', {
    attrs: {
      "id": "dots"
    }
  }, [_vm._l((_vm.dots), function(dot) {
    return [_c('dot', {
      attrs: {
        "cx": dot.cx,
        "cy": dot.cy,
        "r": dot.r,
        "fill": dot.fill,
        "opacity": !isNaN(dot.opacity) ? dot.opacity : 0.6
      }
    })]
  })], 2)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedSim == false),
      expression: "startedSim == false"
    }],
    key: "intro",
    staticClass: "intro"
  }, [_c('h1', [_vm._v("Reaction Rates")]), _vm._v(" "), _c('p', [_vm._v("Examine a chemical reaction and then investigate variables that can affect its rate.")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.runControlReaction
    }
  }, [_vm._v("Run Reaction")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedSim == 'kinda'),
      expression: "startedSim == 'kinda'"
    }],
    key: "simstart",
    staticClass: "simstart"
  }, [_c('svg', {
    staticClass: "graph",
    attrs: {
      "width": "300",
      "height": "300",
      "viewBox": "0 0 300 300"
    }
  }, [_c('g', {
    attrs: {
      "id": "ctrlGraph"
    }
  }, [_c('g', {
    attrs: {
      "id": "ctrlLabelsnlines"
    }
  }, [_c('text', {
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "x": "-200",
      "y": "10",
      "font-family": "proxima-nova",
      "font-size": "13",
      "fill": "#797d82"
    }
  }, [_vm._v("Amount of Product")]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "140",
      "y": "300",
      "font-family": "proxima-nova",
      "font-size": "13",
      "fill": "#797d82"
    }
  }, [_vm._v("Time")]), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "275",
      "x2": "275",
      "y2": "275",
      "stroke": "#797d82"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "25",
      "x2": "25",
      "y2": "275",
      "stroke": "#797d82"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clock",
    attrs: {
      "cx": "278",
      "cy": "32",
      "r": "21",
      "stroke": "#ccc",
      "stroke-width": "1.8",
      "fill": "#ffffff"
    }
  }), _vm._v(" "), _c('line', {
    staticStyle: {
      "fill": "none",
      "stroke": "#ccc",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "5px"
    },
    attrs: {
      "x1": "274.06",
      "y1": "3.84",
      "x2": "280.66",
      "y2": "3.84"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "hand",
    class: _vm.startSpinning,
    staticStyle: {
      "fill": "#797d83"
    },
    attrs: {
      "d": "M280.25,26.25c.07,2.59-1.2,4.72-2.85,4.77s-3-2-3.11-4.6S277,15.19,277,15.19,280.18,23.66,280.25,26.25Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ctrlGraphdata"
    }
  }, [_c('line', {
    attrs: {
      "x1": "25",
      "y1": "275",
      "x2": _vm.ctrlGoing.x,
      "y2": _vm.ctrlGoing.y,
      "stroke": "#CC00F0"
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.mixItUp
    }
  }, [_vm._v("Select Variables →")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedSim == true),
      expression: "startedSim == true"
    }],
    key: "sim",
    staticClass: "sim"
  }, [_c('h1', [_vm._v("Variables")]), _vm._v(" "), _c('v-exselect', {
    staticClass: "variables",
    attrs: {
      "options": ['Catalyst', 'Concentration', 'Surface Area', 'Temperature', 'Control'],
      "searchable": false
    },
    model: {
      value: (_vm.reactionVariable),
      callback: function($$v) {
        _vm.reactionVariable = $$v
      },
      expression: "reactionVariable"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons",
    class: _vm.showButtons == true ? 'show' : ''
  }, [_c('button', {
    staticClass: "btn grey",
    class: _vm.increaseOrDecrease == 'decrease' ? 'dark' : '',
    attrs: {
      "disabled": _vm.step === 2
    },
    on: {
      "click": _vm.decrease
    }
  }, [_vm._v("Decrease")]), _vm._v(" "), _c('button', {
    staticClass: "btn grey",
    class: _vm.increaseOrDecrease == 'increase' ? 'dark' : '',
    attrs: {
      "disabled": _vm.step === 2
    },
    on: {
      "click": _vm.increase
    }
  }, [_vm._v("Increase")])]), _vm._v(" "), _c('svg', {
    staticClass: "graph",
    attrs: {
      "width": "300",
      "height": "300",
      "viewBox": "0 0 300 300"
    }
  }, [_c('g', {
    attrs: {
      "id": "graph"
    }
  }, [_c('g', {
    attrs: {
      "id": "labelsnlines"
    }
  }, [_c('text', {
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "x": "-200",
      "y": "10",
      "font-family": "proxima-nova",
      "font-size": "13",
      "fill": "#797d82"
    }
  }, [_vm._v("Amount of Product")]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "140",
      "y": "300",
      "font-family": "proxima-nova",
      "font-size": "13",
      "fill": "#797d82"
    }
  }, [_vm._v("Time")]), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "275",
      "x2": "275",
      "y2": "275",
      "stroke": "#797d82"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "25",
      "x2": "25",
      "y2": "275",
      "stroke": "#797d82"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "clock",
    attrs: {
      "cx": "278",
      "cy": "32",
      "r": "21",
      "stroke": "#ccc",
      "stroke-width": "1.8",
      "fill": "#ffffff"
    }
  }), _vm._v(" "), _c('line', {
    staticStyle: {
      "fill": "none",
      "stroke": "#ccc",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "5px"
    },
    attrs: {
      "x1": "274.06",
      "y1": "3.84",
      "x2": "280.66",
      "y2": "3.84"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "hand",
    class: _vm.startSpinning,
    staticStyle: {
      "fill": "#797d83"
    },
    attrs: {
      "d": "M280.25,26.25c.07,2.59-1.2,4.72-2.85,4.77s-3-2-3.11-4.6S277,15.19,277,15.19,280.18,23.66,280.25,26.25Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "graphdata"
    }
  }, [_c('line', {
    attrs: {
      "x1": "25",
      "y1": "275",
      "x2": _vm.going.x,
      "y2": _vm.going.y,
      "stroke": "#CC00F0"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "275",
      "x2": _vm.varGoing.x,
      "y2": _vm.varGoing.y,
      "stroke": "#CC00F0",
      "stroke-width": "2",
      "stroke-dasharray": "4, 8",
      "stroke-linecap": "round"
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: _vm.canRunReaction == false ? 'disabled' : '',
    attrs: {
      "disabled": _vm.canRunReaction == false
    },
    on: {
      "click": _vm.runReaction
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.runReactionLabel)
    }
  })])], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "a"
  }, [_vm._v("A")]), _vm._v(" + "), _c('span', {
    staticClass: "b"
  }, [_vm._v("B")]), _vm._v(" ⟶ "), _c('span', {
    staticClass: "c"
  }, [_vm._v("C")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd019f78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 71
// module chunks = 1